



















































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { FlowForm } from '@/models/FlowForm.type';
import { StepMetaData } from '@/models/StepConfig.type';

import { VueTelInput } from 'vue-tel-input';

@Component({
  components: { VueTelInput }
})
export default class OnboardingFlow extends Vue {
  form: FlowForm = {
    firstName: null,
    lastName: null,
    jobTitle: null,
    emailAddress: null,
    phoneNumber: null
  };

  activeStepIndex = 0;

  steps: StepMetaData[] = [
    {
      title: 'Welcome to Parsyl!',
      component: 'Welcome',
      autofocus: false
    },
    {
      title: 'Tell us about yourself',
      component: 'PersonalInfo',
      autofocus: true
    },
    {
      title: 'Contact information',
      component: 'Contact',
      autofocus: true
    },
    {
      title: 'What kind of work do you intend to do with Parsyl?',
      component: 'Work',
      autofocus: false
    }
  ];

  get activeStep() {
    return this.steps[this.activeStepIndex];
  }

  get nextButtonText() {
    if (this.activeStepIndex === 0) return 'Get Started';
    else return 'next';
  }

  next(): void {
    if (this.isCurrentFormValid()) this.activeStepIndex += 1;
    this.autofocus();
  }
  back(): void {
    this.clearValidation();
    this.activeStepIndex -= 1;
    this.autofocus();
  }

  autofocus(): void {
    if (!this.steps[this.activeStepIndex].autofocus) return;
    const formName = `${this.steps[this.activeStepIndex].component}Form`;
    this.$nextTick(() => (this.$refs[formName] as any).$el.elements[0].focus());
  }

  validateContact(rule: {}, value: string, callback: Function): void {
    const { phoneNumber, emailAddress } = this.form;
    const atLeastOneInput = !!phoneNumber || !!emailAddress;
    if (atLeastOneInput) {
      callback();
    } else {
      callback(new Error('Either an email OR a phone number is required'));
    }
  }

  currentForm(): any {
    return this.$refs[`${this.activeStep.component}Form`];
  }

  isCurrentFormValid(): boolean {
    let formIsValid = false;

    const form = this.currentForm();
    if (!form) return !formIsValid;

    form.validate((valid: boolean) => (formIsValid = valid));

    return formIsValid;
  }

  forceValidation(): void {
    this.currentForm().validate();
  }

  clearValidation(): void {
    const form = this.currentForm();
    if (form) form.clearValidate();
  }

  continueToWebapp() {
    this.activateUser();
    // console.log('navigate to webapp');
    window.location.assign('https://app.test.parsyl.com');
  }

  continueToUnoptomizedWebappView() {
    this.activateUser();
    this.$router.push({
      name: 'unoptomized',
      params: { emailAddress: this.form.emailAddress as string }
    });
  }

  continueToAppDownload() {
    this.activateUser();
    // console.log('continue to app download');
    this.$router.push({
      name: 'mobile',
      params: { phoneNumber: this.form.phoneNumber as string }
    });
  }

  activateUser() {
    // console.log('POST to backend, activate user', this.form);
  }
}
